import {inlineError} from '@s-ui/decorators/lib/index.js'
import {UseCase} from '@s-ui/domain'

import {TransactionsMappersFactory} from '../Mappers/factory.js'
import {HTTPTransactionRepository} from '../Repositories/HTTPTransactionRepository.js'

/**
 * @implements UseCase
 */
class GetLoanCalculationsTransactionsUseCase extends UseCase {
  #httpTransactionsRepository
  #fromUseCaseParamsToGetLoanCalculationsTransactionsRequestMapper

  constructor({fromUseCaseParamsToGetLoanCalculationsTransactionsRequestMapper, httpTransactionsRepository}) {
    super()
    this.#fromUseCaseParamsToGetLoanCalculationsTransactionsRequestMapper =
      fromUseCaseParamsToGetLoanCalculationsTransactionsRequestMapper
    this.#httpTransactionsRepository = httpTransactionsRepository
  }

  static create({config}) {
    return new GetLoanCalculationsTransactionsUseCase({
      fromUseCaseParamsToGetLoanCalculationsTransactionsRequestMapper:
        TransactionsMappersFactory.fromUseCaseParamsToGetLoanCalculationsTransactionsRequestMapper({config}),
      httpTransactionsRepository: HTTPTransactionRepository.create({config})
    })
  }

  @inlineError
  async execute({carPlateRegistrationDate, lender, openingFee, price, terms}) {
    const getLoanCalculationsTransactionsRequest =
      this.#fromUseCaseParamsToGetLoanCalculationsTransactionsRequestMapper.map({
        carPlateRegistrationDate,
        lender,
        openingFee,
        price,
        terms
      })

    const [error, response] = await this.#httpTransactionsRepository.getLoanCalculations({
      getLoanCalculationsTransactionsRequest
    })

    if (error) throw error
    return response.toJSON()
  }
}

export const factory = GetLoanCalculationsTransactionsUseCase.create
